module.exports = __webpack_public_path__ + "static/img/produce18.4087c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce18.png
// module id = 148
// module chunks = 4